// @ts-nocheck
import * as React from 'react';
import * as ReactDOM from 'react-dom';
// @ts-ignore
import scrollIntoView from 'dom-scroll-into-view';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import classNames from 'classnames';
import {
  mcDropDown,
  mcDropDownBack,
  mcTreeCollapse,
  mcTreeExpand,
} from '@mc/react-ui-icons';

let _debugStates = false;

type IShouldItemRenderFunc = (item: any, value: string) => boolean;

type IdType = number | string;

type TreeType<T> = T & { expanded?: boolean; children: TreeType<T>[] };

type TreeExpandedType = { [key in IdType]: boolean };

function getScrollOffset(elem: any): { left: number; top: number } {
  let left = 0,
    top = 0;

  do {
    left += elem.scrollLeft;
    top += elem.scrollTop;
  } while ((elem = elem.offsetParent));

  return { left, top };
}

export type BaseAutocompleteProps<T, VAL_TYPE = T> = {
  className?: string;
  // initialValue: any;
  /** @default true - jestli se má použít pro filtrování interní filtr - typicky pokud list položek známe (na server našeptání by mělo být false) */
  useAutocompleteInternalFilter?: boolean;
  /** @default true */
  showMenuOnFocus?: boolean;
  // implicitně true, pokud je false, tak klik na dropdown ikonu nezobrazuje menu
  dropDownIconClickOpenMenu?: boolean;
  // Má se zobrazoivat dropdown ikona? Implicitně true.
  hasDropdownIcon?: boolean;
  getDropDownIcon?: (isOpen: boolean) => IconDefinition;
  onCloseMenu?: () => void;
  onOpenMenu?: () => void;
  /**
   * Field může podporovat potvrzení hodnoty položky, typicky pro možnost např. hledání ve filtrech. Většina implementací volá tuto metodu na enter.
   */
  onSearch?: () => void;
  onFocus?: (val?: VAL_TYPE) => void;
  onBlur?: (val?: VAL_TYPE) => void;
  /**
   * Pokud je zapnuto a není vybraný item, vrátí po stisknutí entru napsaný text. Nevolá se, pokud je povoleno allowCreateItems nebo tags.
   * Pokud je zapnuta, nezůstává po výběru položka ve state.
   */
  onSearchByText?: (val: string) => void;
  /**
   * Pokud je zapnuto, je nutné definovat i getNewItem. Pokud je true, tak se automaticky do value dává hodnota získaná pomocí getNewItem - tedy je možné do value uložit i hodnotu, která není v items.
   */
  allowCreateItems?: boolean;
  /**
   * Pro předaný text vrátí objekt, který je stejného typu jako item předávaný v items, voláno pokud je allowCreateItems povoleno
   * @param text
   */
  getNewItem?: (text: string) => T;
  /**
   * načtení id položky, předpis: (item @Nullable) => {}
   * @default i => i.id
   */
  getItemId?: (item: T) => IdType;
  /**
   * načtení textu položky (např. do inputu po výběru), předpis: (item @Nullable) => {}
   * @default i => i.name || i.nazev || ''
   */
  getItemName?: (item: T) => {};
  /**
   * render obsahu položky - jen samotný obsah bez rozbalovátka u stromu, stylů na focus a select apod., předpis: (item, name) => {}
   */
  renderItemContent?: React.ReactNode;
  /** render obsahu title (itemsTitle a favoriteItemsTitle) položky - jen samotný obsah bez stylů na focus a select apod., předpis: (item, name) => {} */
  renderTitleItemContent?: (item: T, name: string) => string | null;
  onChange?: (val?: VAL_TYPE) => void;
  /** callback volaný při změně zapsaného textu v poli */
  onTextChange?: (value: string) => void;
  /** pokud je true, pracuje navenek komponenta tak, že jako hodnotu nemá objekt, ale jeho id - stejně jako html select */
  useIdAsValue?: boolean;
  // TODO shouldItemRender move to props
  /** pokud je uvedená, jedná se o metodu, která filtruje jednu položku, předpis: (item, value) => {true|false} */
  shouldItemRender?: IShouldItemRenderFunc;
  renderItem?: React.ReactNode;
  /** načtení doplňující class pro položku - aby nebylo nutné měnit kvůli class celý renderItem */
  getItemRenderClass?: (item: T) => string | null;
  /** pokud je true, budou vždy všechny položky ve stromu rozbalené () */
  alwaysExpanded?: boolean;
  inputProps?: React.HTMLProps<HTMLInputElement>;
  actions?: React.ReactNode[];
  /**
   * @deprecated není úplně podporováno - možná spíše již nepodporováno
   */
  tags?: boolean;
  inline?: boolean;
  touched?: boolean;
  error?: string;
  /** vrací true, pokud je možné řádek vybrat jako hodnotu, předpis: (id, item) => {} */
  allowSelectItem?: (id: IdType, item: T) => boolean;
  /** vrací true, pokud se na řádek dá najet focusem, např. přes klávesnici, předpis: (id, item) => {} */
  allowFocusItem?: (id: IdType, item: T) => boolean;
  /** jedná se o stromovou reprezentaci dat? */
  tree?: boolean;
  /** pokud je uvedena, jedná se o řádek, který uvozuje seznam položek pokud je favoriteItems */
  itemsTitle?: string;
  /** pokud je uvedena, jedná se o řádek, který uvozuje seznam oblíbených položek pokud je favoriteItems */
  favoriteItemsTitle?: string;
  /** pokud je uvedena, zobrazuje se pokud je nějaké hledání a nic se nevrátilo, obsahuje standardně implicitní text */
  noItemsFound?: string;
  placeholder?: string;
  items: T[];
  favoriteItems?: T[];
  autoFocus?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  dataTest?: string;
  value?: VAL_TYPE;
  /**
   * Standardně je možné smazat hodnotu, pokud má selectbox mít vždy nějakou hodnotu, je možné zapnout pomocí allowNullValue=false - při prvním vybrání hodnoty už vždy nějakou bude mít. Výchozí hodnota allowNullValue je true.
   */
  allowNullValue?: boolean;
  colors?: boolean;
};

type State<T> = {
  shouldItemRender: IShouldItemRenderFunc;
  value: T;
  inputStrValue?: string;
  isOpen: boolean;
  menuParentStyle: {};
  highlightedIndex?: number;
  hasFocus: boolean;
  changed: boolean;
  dataTest?: string;
};

/**
 * Komponenta pro text input - definována pro překrytí a kontrolu shouldComponentUpdate. Pokud se v autocomplete
 * dovyplní a označí zbytek textu a input se překreslil, zmizel daný text. Tato komponenta tomu zzabrání - testuje změnu value.
 */
export class BaseAutocomplete<T, VAL_TYPE = T> extends React.Component<
  BaseAutocompleteProps<T, VAL_TYPE>,
  State<T>
> {
  _ignoreBlur: boolean;
  requestId: number;
  inputRef: React.RefObject<HTMLInputElement>;

  state: State<T>;

  // @ts-ignore
  constructor(props) {
    super(props);

    this._ignoreBlur = false;

    this.requestId = 1;

    this.state = {
      ...this.getStateFromProps({}, props, {
        inputStrValue: '',
        changed: false,
        items: [],
      }),
      isOpen: false,
      menuParentStyle: {},
      highlightedIndex: null,
      hasFocus: false,
      changed: false,
    };
    this.inputRef = React.createRef();
  }

  static defaultProps = {
    useIdAsValue: false,
    hasDropdownIcon: true,
    getDropDownIcon: (isOpen: boolean) =>
      isOpen ? mcDropDownBack : mcDropDown,
    dropDownIconClickOpenMenu: true,
    useAutocompleteInternalFilter: true,
    showMenuOnFocus: true,
    noItemsFound: 'Pro zadaný řetězec nebyly nalezeny žádné záznamy',
    inputProps: {},
    onChange() {},
    allowSelectItem() {
      // vrati true, když může být daná položka vybrána
      return true;
    },
    // @ts-ignore
    allowFocusItem(id, item) {
      // vrati true, když může na danou položku najet klávesnicí nebo myší a může být focusovatelná
      return true;
    },
    getItemId: (item?: { id: IdType }) => (item ? item.id : null),
    getItemName: (item?: { name?: string; nazev?: string }) =>
      item ? item.name || item.nazev || '' : '',
    // @ts-ignore
    getItemRenderClass: (item) => undefined,
    alwaysExpanded: false,
    // @ts-ignore
    renderItemContent: (item, name) => {
      if (name && name.length > 0) {
        return <span className="item-text">{name}</span>;
      } else {
        return <span className="item-text">&nbsp;</span>;
      }
    },
    // @ts-ignore
    renderTitleItemContent: (item, name) => {
      if (name && name.length > 0) {
        return <span className="item-text">{name}</span>;
      } else {
        return <span className="item-text">&nbsp;</span>;
      }
    },
    renderItem: (
      // @ts-ignore
      item,
      // @ts-ignore
      itemId,
      // @ts-ignore
      name,
      // @ts-ignore
      renderItemContent,
      // @ts-ignore
      isHighlighted,
      // @ts-ignore
      isSelected,
      allowSelect = true,
      allowFocus = true,
      // @ts-ignore
      treeInfo?: {
        expanded;
        depth;
        onExpandCollapse;
      } = null /*{expanded, depth, onExpandCollapse}*/,
      // @ts-ignore
      getItemRenderClass,
      colors
    ) => {
      const cls = classNames(
        'item',
        getItemRenderClass(item),
        {
          focus: isHighlighted,
          active: isSelected,
          'not-selectable': !allowSelect,
          'not-focusable': !allowFocus,
        },
        item.className
      );

      const itemContent = renderItemContent(item, name);

      let treeTogle;
      let depth;
      let colorSquare;

      if (treeInfo) {
        const depthItems = [];
        for (let a = 0; a < treeInfo.depth; a++) {
          depthItems.push(<div className="depth-item"></div>);
        }
        depth = <div className="depth-container">{depthItems}</div>;

        if (item.children && item.children.length > 0) {
          treeTogle = (
            <div
              className={`node-expand-collapse ${
                treeInfo.expanded ? 'expanded' : 'collapsed'
              }`}
              onClick={treeInfo.onExpandCollapse}
            >
              <FontAwesomeIcon
                icon={treeInfo.expanded ? mcTreeCollapse : mcTreeExpand}
                className="toggle-button"
              />
            </div>
          );
        } else {
          treeTogle = <div className={`node-expand-collapse`}></div>;
        }
      }

      if (colors) {
        colorSquare = (
          <div className="color-box" style={{ backgroundColor: itemId }} />
        );
      }

      return (
        <div className={cls} key={itemId}>
          {depth}
          {treeTogle}
          {colorSquare}
          {itemContent}
        </div>
      );
    },
    inline: false,
    // @ts-ignore
    error: null,
    touched: false,
    tree: false,
    tags: false,
    // @ts-ignore
    actions: undefined,
    placeholder: '',
  };

  /**
   * Získání indexu další možné položky pro focus.
   * @param index aktuální index
   * @param loop pokud je true, focus na položkách cykluje
   * @return další možná položka nebo index, pokud jiná není
   */
  // @ts-ignore
  getNextFocusableItem = (index, loop) => {
    const { allowFocusItem, getItemId } = this.props;
    const items = this.getFilteredItems();

    if (items == null) {
      return null;
    }

    const start = index !== null ? index : 0;
    var ii = index != null ? start + 1 : start;
    if (ii >= items.length) {
      // na konci přejdeme na začátek
      if (!loop) return null;

      ii = 0;
    }
    while (true) {
      var item = items[ii];
      if (this.callAllowFocusItem(allowFocusItem, getItemId(item), item)) {
        return ii;
      }
      ii++;

      if (ii >= items.length) {
        // na konci přejdeme na začátek
        if (!loop) return null;

        ii = 0;
      }
      if (ii === start) {
        // udělali jsme celé kolečko a nenalezli položku, na kterou se může dát další focus
        return index;
      }
    }
  };

  // @ts-ignore
  callAllowFocusItem = (allowFocusItem, itemId, item) => {
    if (item && item._titleLabel) {
      return false;
    }
    return allowFocusItem ? allowFocusItem(itemId, item) : true;
  };

  // @ts-ignore
  callAllowSelectItem = (allowSelectItem, itemId, item) => {
    if (item && item._titleLabel) {
      return false;
    }
    return allowSelectItem ? allowSelectItem(itemId, item) : true;
  };

  /**
   * Získání indexu předchozí možné položky pro focus.
   * @param index aktuální index
   * @param loop pokud je true, focus na položkách cykluje
   * @return další možná položka nebo index, pokud jiná není
   */
  // @ts-ignore
  getPrevFocusableItem = (index, loop) => {
    const { allowFocusItem, getItemId } = this.props;
    const items = this.getFilteredItems();

    if (items == null) {
      return null;
    }

    const start = index !== null ? index : items.length - 1;
    var ii = index !== null ? index - 1 : start;
    if (ii < 0) {
      // na konci přejdeme na začátek
      if (!loop) return null;

      ii = items.length - 1;
    }
    while (true) {
      var item = items[ii];
      if (this.callAllowFocusItem(allowFocusItem, getItemId(item), item)) {
        return ii;
      }
      ii--;

      if (ii < 0) {
        // na konci přejdeme na začátek
        if (!loop) return null;

        ii = items.length - 1;
      }
      if (ii === start) {
        // udělali jsme celé kolečko a nenalezli položku, na kterou se může dát další focus
        return index;
      }
    }
  };

  getItemsTitleItem = (props = this.props) => {
    const { itemsTitle } = props;
    return !itemsTitle
      ? null
      : {
          _titleLabel: true,
          _items: true,
          name: itemsTitle,
        };
  };

  getNoItemsFoundItem = (props = this.props) => {
    const { noItemsFound } = props;
    return !noItemsFound
      ? null
      : {
          _titleLabel: true,
          _noItemsFound: true,
          name: noItemsFound,
        };
  };

  getFavoriteItemsTitleItem = (props = this.props) => {
    const { favoriteItemsTitle } = props;
    return !favoriteItemsTitle
      ? null
      : {
          _titleLabel: true,
          _favoriteItems: true,
          name: favoriteItemsTitle,
        };
  };

  /**
   * Rozbalení nebo zabalení položky ve stromu.
   * @param node položka
   * @param expand true, pokud se má rozbalit
   */
  // @ts-ignore
  expandNode = (node, expand) => {
    // @ts-ignore
    const { changed, expandedIds, inputStrValue, shouldItemRender } =
      this.state;
    const {
      favoriteItems,
      alwaysExpanded,
      items,
      tree,
      getItemId,
      getItemName,
      allowSelectItem,
      allowFocusItem,
    } = this.props;
    const noItemsFoundItem = this.getNoItemsFoundItem();
    const favoriteItemsTitleItem = this.getFavoriteItemsTitleItem();
    const itemsTitleItem = this.getItemsTitleItem();
    const id = this.props.getItemId(node);
    let newExpandedIds;

    if (expand) {
      newExpandedIds = { ...expandedIds, [id]: true };
    } else {
      newExpandedIds = { ...expandedIds };
      delete newExpandedIds[id];
    }

    const filterText = changed ? inputStrValue : '';
    const favoriteInfo = {
      favoriteItems,
      itemsTitleItem,
      favoriteItemsTitleItem,
    };
    const newItemsInfo = this.getNewFilteredItems(
      items,
      favoriteInfo,
      null,
      shouldItemRender,
      filterText,
      tree,
      newExpandedIds,
      getItemId,
      getItemName,
      allowSelectItem,
      allowFocusItem,
      false,
      alwaysExpanded,
      noItemsFoundItem
    );

    this.changeState({
      expandedIds: newExpandedIds,
      items: newItemsInfo.items,
      itemsDepth: newItemsInfo.itemsDepth,
    });
  };

  /**
   * Metoda pro změnu stavu - měla by se volat místo this.setState, protože kontroluje, zda se mají položky přefiltrovat.
   * @param nextState
   * @param callback
   */
  // @ts-ignore
  changeState = (nextState, callback = null) => {
    this.setState(nextState, callback);
  };

  focus = () => {
    this.inputRef.current.focus();
  };

  // @ts-ignore
  isUnderEl(parentEl, el) {
    while (el !== null) {
      if (el === parentEl) {
        return true;
      }
      el = el.parentNode;
    }
    return false;
  }

  // @ts-ignore
  componentWillReceiveProps(nextProps) {
    const newState = this.getStateFromProps(this.props, nextProps, this.state);
    // console.log("PREV state", this.state, "NEW state", newState);
    // @ts-ignore
    this.setState(newState);
  }

  // @ts-ignore
  getStateFromProps = (props, nextProps, state) => {
    var shouldItemRender;
    var changed = state.changed;
    if (nextProps.shouldItemRender) {
      shouldItemRender = nextProps.shouldItemRender;
    } else {
      // @ts-ignore
      shouldItemRender = (item, value) => {
        return (
          nextProps
            .getItemName(item)
            .toLowerCase()
            .normalize('NFD')
            .replace(/\p{Diacritic}/gu, '')
            .indexOf(
              value
                .toLowerCase()
                .normalize('NFD')
                .replace(/\p{Diacritic}/gu, '')
            ) !== -1
        );
      };
    }

    // ---
    var inputStrValue;
    const prevRealValue = this.getRealValue(props.value, props);
    const nextRealValue = this.getRealValue(nextProps.value, nextProps);
    var prevId = props.getItemId
      ? props.getItemId(prevRealValue)
      : nextProps.getItemId(prevRealValue);
    var newId = nextProps.getItemId(nextRealValue);
    _debugStates &&
      console.log(
        'getStateFromProps',
        'prevId',
        prevId,
        'newId',
        newId,
        'state',
        state
      );
    if (prevId != newId) {
      // Změna stavu, při které byla vybrána jiná položka.
      changed = false;
      inputStrValue = nextProps.getItemName(nextRealValue);
      if (typeof inputStrValue === 'undefined') {
        inputStrValue = '';
      }
    } else if (prevId == newId && !state.changed) {
      /* pokud došlo ke změně stavu, při které zůstala vybrána stejná položka
             a nebyl změněn vyhledávaný text ručně.*/
      inputStrValue = nextProps.getItemName(nextRealValue);
    } else {
      inputStrValue = state.inputStrValue;
    }

    // ---

    // Pokud se jedná o první zobrazení nebo změnu položek items, přefiltrujeme položky
    let filterResult;
    if (props.items !== nextProps.items) {
      const filterText = changed ? inputStrValue : '';
      filterResult = this.getFilteredResult(
        filterText,
        state.changed,
        nextProps,
        state,
        nextProps.items
      );
    } else {
      filterResult = {
        items: state.items,
      };
    }

    // ---

    let highlightedIndex = state.highlightedIndex;
    if (nextRealValue) {
      const showHighlightedIndex = this.getHighlightedIndexByValue(
        nextRealValue,
        // @ts-ignore
        filterResult.items,
        nextProps.getItemId
      );
      if (highlightedIndex !== showHighlightedIndex) {
        highlightedIndex = showHighlightedIndex;
      }
    }

    // ---
    var result = {
      ...filterResult,
      shouldItemRender: shouldItemRender,
      highlightedIndex,
      value: nextRealValue,
      inputStrValue: inputStrValue,
      changed: changed,
    };

    _debugStates && console.log('getStateFromProps', result);

    return result;
  };

  getRealValue = (value: VAL_TYPE, props = this.props): T | null => {
    const { useIdAsValue } = props;
    if (!useIdAsValue) {
      return value as any as T;
    }
    if (value == null || (value as any as string) == '') {
      return value as any;
    }

    const { getItemId } = props;
    // Prošli jsme přes !useIdAsValue a hodnota není prázdná -> value === IdType
    return this.getRealValueInTree(
      value as any as IdType,
      props.items,
      getItemId
    );
  };

  /**
   * Nalezení Objektu ve stromu / listu pomocí jeho ID
   */
  getRealValueInTree = (
    value: IdType,
    items: T[],
    getItemId: (i: T) => IdType
  ): T | null => {
    for (const item of items) {
      if (getItemId(item) === value) {
        return item;
      }

      if ((item as TreeType<T>).children) {
        let res = this.getRealValueInTree(
          value,
          (item as TreeType<T>).children,
          getItemId
        );
        if (res) {
          return res;
        }
      }
    }

    return null;
  };

  // @ts-ignore
  handleDocumentScroll = (e) => {
    this.setMenuPositions();
  };

  // @ts-ignore
  handleDocumentClick = (e) => {
    _debugStates &&
      console.log(
        'STATE has focus',
        this.state.hasFocus,
        'ignore blur',
        this._ignoreBlur
      );

    var el1 = this.inputRef.current;
    var el2 = ReactDOM.findDOMNode(this.refs.menuParent);
    var el3 = ReactDOM.findDOMNode(this.refs.openClose);
    const el4 = ReactDOM.findDOMNode(this.refs.actions);
    var el = e.target;
    var inside = false;
    while (el !== null) {
      if (el === el1 || el === el2 || el === el3 || el === el4) {
        inside = true;
        break;
      }
      el = el.parentNode;
    }
    _debugStates && console.log('@CLICK:', inside);
    if (!inside) {
      // @ts-ignore
      var el = this.inputRef.current;
      if (this.state.hasFocus && document.activeElement !== el) {
        // víme, že má focus, ale nemá focus vlastní input, budeme simulovat blur
        this._ignoreBlur = true;
        el.focus();
        this._ignoreBlur = false;
        el.blur();
      }
      this._ignoreBlur = false;

      if (this.props.allowCreateItems && this.state.changed) {
        const item = this.props.getNewItem(this.state.inputStrValue);

        this.changeState(
          {
            inputStrValue: '',
            value: '',
            isOpen: false,
            menuParentStyle: {},
            // highlightedIndex: null
          },
          () => {
            // @ts-ignore
            this.callOnChange(item);
          }
        );
      }

      this.closeMenu(false, true, false);
    } else if (
      this.state.hasFocus &&
      (this.isUnderEl(el2, e.target) ||
        this.isUnderEl(el3, e.target) ||
        this.isUnderEl(el4, e.target))
    ) {
      this._ignoreBlur = true;
    } else {
      this._ignoreBlur = false;
    }
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleDocumentClick, false);
    document.addEventListener('scroll', this.handleDocumentScroll, false);

    if (this.props.autoFocus) {
      setTimeout(() => {
        this.inputRef.current.focus();
      }, 30);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleDocumentClick, false);
    document.removeEventListener('scroll', this.handleDocumentScroll, false);
  }

  // @ts-ignore
  renderMenuContainer(items) {
    const { highlightedIndex, menuParentStyle } = this.state;
    // @ts-ignore
    const { header, footer } = this.props;

    let cls =
      'autocomplete-menu-container' +
      (highlightedIndex != null ? ' active' : '');

    let headerComp;
    if (header) {
      cls += ' has-header';
      headerComp = <div className="autocomplete-menu-header">{header}</div>;
    }

    let footerComp;
    if (footer) {
      cls += ' has-footer';
      if (typeof footer === 'function') {
        footerComp = (
          <div className="autocomplete-menu-footer">
            {React.createElement(footer, {
              closeMenu: () => {
                this.closeMenu(false, false, false);
              },
            })}
          </div>
        );
      } else {
        footerComp = <div className="autocomplete-menu-footer">{footer}</div>;
      }
    }

    return (
      <div ref="menuParent" className={cls} style={menuParentStyle}>
        {headerComp}
        <div className="autocomplete-menu-wrapper">
          <div ref="menu" className="autocomplete-menu">
            {items}
          </div>
        </div>
        {footerComp}
      </div>
    );
  }

  componentWillMount() {
    this._ignoreBlur = false;
  }

  // @ts-ignore
  componentDidUpdate(prevProps, prevState) {
    // @ts-ignore
    if (
      prevState.items !== this.state.items ||
      prevState.isOpen !== this.state.isOpen
    ) {
      // pokud nastala změna zobrazení (zobrazení menu) nebo se změnil počet položek (fulltextové hledání), musíme správně napozicovat
      this.setMenuPositions();
    }

    // this.disableScroll(prevState);
    this.maybeScrollItemIntoView();
  }

  // preventDefaultScroll = (e: { preventDefault: () => void }) => {
  //   const autocompleteMenu = document.querySelector(
  //       '.autocomplete-menu-wrapper'
  //   );
  //   autocompleteMenu?.scrollBy(0, e.deltaY);
  //   e.preventDefault();
  // };

  // disableScroll = (prevState: any) => {
  //   if (prevState.isOpen !== this.state.isOpen) {
  //     const body = document.querySelector('body');
  //
  //     if (this.state.isOpen) {
  //       // Attach the handleWheel function as an event listener to each number input
  //       body?.addEventListener('wheel', this.preventDefaultScroll, {
  //         passive: false,
  //       });
  //     } else {
  //       // Clean up by removing the event listeners when the component unmounts
  //       body?.removeEventListener('wheel', this.preventDefaultScroll);
  //     }
  //   }
  // };

  maybeScrollItemIntoView = () => {
    if (this.state.isOpen === true && this.state.highlightedIndex !== null) {
      // Pro scroll použijeme (pokud možno) předchozí položku, aby byl vidět i label např. oblíbených, pokud je použit
      const favoriteItemsTitleItem = this.getFavoriteItemsTitleItem();
      let scrollIndex;
      if (favoriteItemsTitleItem && this.state.highlightedIndex === 1) {
        scrollIndex = this.state.highlightedIndex - 1;
      } else {
        scrollIndex = this.state.highlightedIndex;
      }

      var itemNode = ReactDOM.findDOMNode(this.refs[`item-${scrollIndex}`]);
      if (!itemNode) {
        return;
      }
      var menuNode = ReactDOM.findDOMNode(this.refs.menu).parentNode;
      scrollIntoView(itemNode, menuNode, { onlyScrollIfNeeded: true });
    }
  };

  // @ts-ignore
  handleKeyDown = (event) => {
    // @ts-ignore
    if (keyDownHandlers[event.key]) {
      // @ts-ignore
      keyDownHandlers[event.key].call(this, event);
    }
  };

  // @ts-ignore
  handleKeyUp = (event) => {
    // @ts-ignore
    if (keyUpHandlers[event.key]) {
      // @ts-ignore
      keyUpHandlers[event.key].call(this, event);
    }
  };

  // @ts-ignore
  getFilteredResult = (filterText, changed, props, state, items) => {
    const { shouldItemRender } = state;

    const result: any = {};
    const realValue = this.getRealValue(props.value, props);
    const includeInViewItemId =
      realValue && !changed ? props.getItemId(realValue) : null; // od položky, která se má ve výsledku object - např. pro strom atp.
    const favoriteInfo = {
      favoriteItems: props.favoriteItems,
      itemsTitleItem: this.getItemsTitleItem(props),
      favoriteItemsTitleItem: this.getFavoriteItemsTitleItem(props),
    };

    const newItemsInfo = this.getNewFilteredItems(
      items,
      favoriteInfo,
      includeInViewItemId,
      shouldItemRender,
      filterText,
      props.tree,
      null,
      props.getItemId,
      props.getItemName,
      props.allowSelectItem,
      props.allowFocusItem,
      true,
      props.alwaysExpanded,
      this.getNoItemsFoundItem(props)
    );
    // @ts-ignore
    result.items = newItemsInfo.items;
    // @ts-ignore
    result.itemsDepth = newItemsInfo.itemsDepth;
    // @ts-ignore
    result.expandedIds = newItemsInfo.newExpandedIds;

    return result;
  };

  // @ts-ignore
  handleChange = (event) => {
    // @ts-ignore
    const { onSearchCallback, allowCreateItems } = this.props;
    const value = event.target.value;

    const inputItems = this.props.items;
    const result = this.props.useAutocompleteInternalFilter
      ? this.getFilteredResult(value, true, this.props, this.state, inputItems)
      : inputItems;

    // @ts-ignore
    const rid = this.requestId++;

    // Přednastavení aktivně označené položky, TODO - musí upravit pro strom atp. - musí brát v úvahu unselected položky atp.
    let highlightedIndex;
    if (this.props.useAutocompleteInternalFilter) {
      if (!allowCreateItems) {
        // jen když není povoleno vytvoření vlastní položky
        if (value) {
          // vyplněný nějaký filtr
          // Vybereme vybíratelnou položku, pokud je více něž jedna
          let allowFocusIndex = null;
          let allowSelectIndex = null;
          let allowFocusCount = 0;
          let allowSelectCount = 0;
          const { getItemId, allowSelectItem, allowFocusItem } = this.props;
          // @ts-ignore
          for (let a = 0; a < result.items.length; a++) {
            // @ts-ignore
            const item = result.items[a];
            // @ts-ignore
            const id = getItemId(item);
            if (this.callAllowFocusItem(allowFocusItem, id, item)) {
              allowFocusCount++;
              if (allowFocusIndex === null) {
                allowFocusIndex = a;
              }
            }
            if (this.callAllowSelectItem(allowSelectItem, id, item)) {
              allowSelectCount++;
              if (allowSelectIndex === null) {
                allowSelectIndex = a;
              }
            }
          }

          if (allowSelectCount > 0) {
            highlightedIndex = allowSelectIndex;
          } else if (allowFocusCount > 0) {
            highlightedIndex = allowFocusIndex;
          } else {
            highlightedIndex = null;
          }
        } else {
          // pokud není vyplněný filtr, nebudeme žádnou položku vybírat
          highlightedIndex = null;
        }
      } else {
        highlightedIndex = null;
      }
    } else {
      highlightedIndex = null;
    }

    this.changeState(
      {
        ...result,
        inputStrValue: value,
        changed: true,
        highlightedIndex,
      },
      () => {
        this.openMenu(false);
        if (this.props.onTextChange) {
          this.props.onTextChange(value);
        }
      }
    );
  };

  getFilteredItems = () => {
    // @ts-ignore
    return this.state.items;
  };

  /**
   * Sestavuje strom pro daný node a jeho podstrom.
   * @param node node
   * @param includeInViewItemId TODO
   * @param lowerFilterText filtr
   * @param newExpandedIds mapa id na true, do kterého se přidají aktuálně rozbalené položky - ty co mají pod sebou ty, co odpovídají filtru
   * @param getItemId funkce pro načtení id z node
   * @param getItemName funkce pro načtení name z node
   * @param shouldItemRender funkce pro filtr
   * @param allowSelectItem funkce, která vrací true, pokud lze položku vybrat
   * @param allowFocusItem funkce, která vrací true, pokud lze na dát focus - ostatní jsou např. informační atp.
   * @param alwaysExpanded pokud je true, budou node označené jako expanded
   * @return {*}
   */
  getFilteredTreeNode = (
    // @ts-ignore
    node,
    // @ts-ignore
    includeInViewItemId,
    // @ts-ignore
    lowerFilterText,
    // @ts-ignore
    newExpandedIds,
    // @ts-ignore
    getItemId,
    // @ts-ignore
    getItemName,
    // @ts-ignore
    shouldItemRender,
    // @ts-ignore
    allowSelectItem,
    // @ts-ignore
    allowFocusItem,
    // @ts-ignore
    alwaysExpanded
  ) => {
    // Podřízené nody
    let someChildrenIncludedInView = false;
    // @ts-ignore
    const nodeChildren = [];
    node.children &&
      // @ts-ignore
      node.children.forEach((subNode) => {
        const newSubNode = this.getFilteredTreeNode(
          subNode,
          includeInViewItemId,
          lowerFilterText,
          newExpandedIds,
          getItemId,
          getItemName,
          shouldItemRender,
          allowSelectItem,
          allowFocusItem,
          alwaysExpanded
        );
        if (newSubNode) {
          if (newSubNode.includeInView) {
            someChildrenIncludedInView = true;
          }
          nodeChildren.push(newSubNode);
        }
      });

    const id = getItemId(node);
    const includeInView = lowerFilterText ? false : includeInViewItemId === id;

    if (nodeChildren.length === 0 && nodeChildren.length === 0) {
      // nemá potomky, chceme ho jen v případě, že je sám slectable a vyhovuje hledanému výrazu nebo že je allowFocusItem na false - ty dáváme vždy
      const selectable = this.callAllowSelectItem(allowSelectItem, id, node);
      const focusable = this.callAllowFocusItem(allowFocusItem, id, node);
      const show = shouldItemRender(node, lowerFilterText || '');
      if (!focusable || ((selectable || focusable) && show) || includeInView) {
        // Pokud potomci neodpovídají hledanému výrazu, můžeme je všechny přidat - hledám podle nadřazeného node a můžu se podívat na potomky - pokud to nebude někde třeba, dáme na konfiguraci
        return {
          ...node,
          includeInView: includeInView || someChildrenIncludedInView,
        };

        // Jen node, bez přidání potomků
        // return {
        //     ...node,
        //     children: null,
        // }
      } else {
        return null;
      }
    }

    // Má potomky, bude vždy rozbalený (nebo je nastaveno vždy mít rozbaleno), pokud je nastaven nějaký filtr - má položky, které filtru odpovídají
    if (lowerFilterText || alwaysExpanded || someChildrenIncludedInView) {
      newExpandedIds[getItemId(node)] = true;
    }

    return {
      ...node,
      expanded:
        lowerFilterText || alwaysExpanded || someChildrenIncludedInView
          ? true
          : false,
      // @ts-ignore
      children: [...nodeChildren],
      includeInView: includeInView || someChildrenIncludedInView,
    };
  };

  // @param alwaysExpanded pokud je true, budou node označené jako expanded
  getFilteredTree = (
    // @ts-ignore
    items,
    // @ts-ignore
    includeInViewItemId,
    // @ts-ignore
    expandedIds,
    // @ts-ignore
    getItemId,
    // @ts-ignore
    getItemName,
    // @ts-ignore
    filterText,
    // @ts-ignore
    newExpandedIds,
    // @ts-ignore
    shouldItemRender,
    // @ts-ignore
    allowSelectItem,
    // @ts-ignore
    allowFocusItem,
    // @ts-ignore
    alwaysExpanded
  ) => {
    // @ts-ignore
    const result = [];

    const lowerFilterText = filterText
      ? filterText.toLocaleLowerCase()
      : filterText;

    // @ts-ignore
    items.forEach((node) => {
      var newNode = this.getFilteredTreeNode(
        node,
        includeInViewItemId,
        lowerFilterText,
        newExpandedIds,
        getItemId,
        getItemName,
        shouldItemRender,
        allowSelectItem,
        allowFocusItem,
        alwaysExpanded
      );
      if (newNode) {
        result.push(newNode);
      }
    });

    // @ts-ignore
    return result;
  };

  /**
   * Provede novou filtraci položek, převede případný stromu na plochý seznam a načte hloubku jednotlivých položek ve stromu.
   * @param items seznam položek
   * @param favoriteInfo informace o oblibenych polozkach, pokud jsou
   * @param includeInViewItemId jaké id se má ve výsledku zobrazit
   * @param shouldItemRender metoda, která vrací informaci, zda se má položka renderovat v případě ne externalFilter
   * @param inputStrValue zadaný vyhledávací výraz
   * @param tree jedná se stromovou komponentu?
   * @param expandedIds mapa aktuálně rozbalených id
   * @param getItemId metoda pro načtení id z položky
   * @param getItemName metoda pro načtení name z položky
   * @param allowSelectItem funkce, která vrací true, pokud lze položku vybrat
   * @param allowFocusItem funkce, která vrací true, pokud lze položku dát focus
   * @param modifyExpanded pokud je true, bude se brát expanded na základě hledání ve stromu, jinak se použije ten předaný jako expandedIds
   * @param alwaysExpanded pokud je true, budou node označené jako expanded (pouze pokud je modifyExpanded === true)
   * @return v případě stromu vrací: { items: [], itemsDepth: [], newExpandedIds: {}}, jinak vrací { items: [] }
   */
  getNewFilteredItems = (
    // @ts-ignore
    items,
    // @ts-ignore
    favoriteInfo,
    // @ts-ignore
    includeInViewItemId,
    // @ts-ignore
    shouldItemRender,
    // @ts-ignore
    inputStrValue,
    // @ts-ignore
    tree,
    // @ts-ignore
    expandedIds,
    // @ts-ignore
    getItemId,
    // @ts-ignore
    getItemName,
    // @ts-ignore
    allowSelectItem,
    // @ts-ignore
    allowFocusItem,
    // @ts-ignore
    modifyExpanded,
    // @ts-ignore
    alwaysExpanded,
    // @ts-ignore
    noItemsFoundItem
  ) => {
    // Sploštění stromu, pokud je potřeba a jeho filtrování
    // @ts-ignore
    let result;
    if (tree) {
      // Filtrování stromu
      let filteredItems;
      let newExpandedIds;
      if (shouldItemRender) {
        newExpandedIds = {};
        filteredItems = this.getFilteredTree(
          items,
          includeInViewItemId,
          expandedIds,
          getItemId,
          getItemName,
          inputStrValue,
          newExpandedIds,
          shouldItemRender,
          allowSelectItem,
          allowFocusItem,
          modifyExpanded && alwaysExpanded
        );
        // filteredItems = items;
      } else {
        filteredItems = items;
      }

      let flatTree;
      if (modifyExpanded) {
        flatTree = this.getFlatTree(filteredItems, newExpandedIds, getItemId);
      } else {
        flatTree = this.getFlatTree(filteredItems, expandedIds, getItemId);
      }
      result = {
        items: flatTree.list,
        itemsDepth: flatTree.depthList,
        newExpandedIds: newExpandedIds,
      };
    } else {
      result = {
        items,
      };

      // Jendoduchý filtr - pouze v případě plochého seznamu - ne stromu, strom se filtruje jinak
      if (shouldItemRender) {
        // @ts-ignore
        let filteredItems = [];
        // @ts-ignore
        let filteredItemsDepth = [];
        // @ts-ignore
        result.items.forEach((item, index) => {
          if (shouldItemRender(item, inputStrValue || '')) {
            filteredItems.push(item);
            // @ts-ignore
            tree && filteredItemsDepth.push(result.itemsDepth[index]);
          }
        });
        // @ts-ignore
        result.items = filteredItems;
        // @ts-ignore
        result.itemsDepth = filteredItemsDepth;
      }
    }

    // Pokud má favorite info a není nastaven filtr, vložíme favorite položky
    let beforeTreeCount = 0; // počet položek, které jsou před stromovými položkami - musíme o ně posunout informace o depth
    if (
      !inputStrValue &&
      favoriteInfo.favoriteItems &&
      favoriteInfo.favoriteItems.length > 0
    ) {
      const items = result.items;

      result.items = [];
      if (favoriteInfo.favoriteItemsTitleItem) {
        beforeTreeCount++;
        result.items.push(favoriteInfo.favoriteItemsTitleItem);
      }
      result.items = [...result.items, ...favoriteInfo.favoriteItems];
      beforeTreeCount += favoriteInfo.favoriteItems.length;

      if (favoriteInfo.itemsTitleItem) {
        beforeTreeCount++;
        result.items.push(favoriteInfo.itemsTitleItem);
      }
      result.items = [...result.items, ...items];

      // beforeTreeCount += 2;   // oba titulky
      // result.items = [
      //     favoriteInfo.favoriteItemsTitleItem,
      //     ...favoriteInfo.favoriteItems,
      //     favoriteInfo.itemsTitleItem,
      //     ...result.items,
      // ];
    }

    if (tree) {
      // posun depth pole
      let arr = [];
      for (let a = 0; a < beforeTreeCount; a++) {
        arr.push(0);
      }
      result.itemsDepth = [...arr, ...result.itemsDepth];
    }

    // Pokud je filtr a nevrátil žádné položky, vypíšeme alespoň noItemsFoundItem, pokud ji máme     - ale jen pokud není povoleno zakládání vlastních položek
    if (
      result.items.length === 0 &&
      noItemsFoundItem &&
      !this.props.allowCreateItems
    ) {
      result.items = [noItemsFoundItem];
    }

    return result;
  };

  setMenuPositions() {
    if (!this.state.isOpen) {
      // jen pokud je menu zobrazeno
      return;
    }

    const node = this.inputRef.current;
    const rect = node.getBoundingClientRect();
    const computedStyle = getComputedStyle(node);
    const marginBottom = parseInt(computedStyle.marginBottom, 0);
    const marginLeft = parseInt(computedStyle.marginLeft, 10);

    const position = {
      x: rect.left + marginLeft,
      y: rect.bottom + marginBottom,
    };
    const inputHeight = rect.height;

    if (this.refs.menuParent) {
      // renderují se nějaké položky
      const elementNode = ReactDOM.findDOMNode(this.refs.menuParent);
      const scrollOffset = getScrollOffset(elementNode.parentNode);
      // const element = $(elementNode);
      // @ts-ignore
      let elementSize = {
        w: elementNode.offsetWidth,
        h: elementNode.offsetHeight,
      };
      const windowSize = { w: window.innerWidth, h: window.innerHeight };

      let x = position.x;
      let y = position.y + 2; // + scrollOffset.top;

      if (y + elementSize.h > windowSize.h) {
        // nevejde se dolu, dáme ho nahoru
        y = y - elementSize.h - inputHeight - 2; // číslo 2 kvůli border 1px

        if (y < 0) {
          // nevejde se nahoru ani dolu, neřešíme
          y = position.y;
        }
      }
      this.setState({
        menuParentStyle: {
          top: y - 1 + 'px',
          left: x + 'px',
          maxWidth: windowSize.w - x + 'px',
          minWidth: rect.width + 'px',
        },
      });
    }
  }

  // @ts-ignore
  highlightItemFromMouse(index) {
    this.changeState({ highlightedIndex: index });
  }

  /** Get value */
  // TODO TS nechápe zápis logicky je toto správně ale TS nezvládá naši podmínku useIdAsValue
  getReturnValue = (item: T): VAL_TYPE => {
    const { getItemId, useIdAsValue } = this.props;
    if (useIdAsValue) {
      return getItemId(item) as any;
    }

    if (!item) {
      return item as any;
    }

    // Pro strom máme v objektu nějaká další data, musíme je odebrat...
    let result: any;
    if (this.props.tree) {
      const { expanded, includeInView, children, ...rest } = item as any;
      result = rest;
    } else {
      result = item;
    }

    return result;
  };

  /**
   * Zavolání on change s předanou hodnotou.
   * Reálné volání on change zavolá podle konfigurace buď s objektem nebo jeho id.
   *
   * @param value hodnota nebo null
   */
  callOnChange = (value: T) =>
    this.props.onChange?.(this.getReturnValue(value));

  /**
   * Zavolání on blur s předanou hodnotou.
   * Reálné volání on blur zavolá podle konfigurace buď s objektem nebo jeho id.
   *
   * @param value hodnota nebo null
   */
  callOnBlur = (value: T) => this.props.onBlur?.(this.getReturnValue(value));

  selectItemFromMouse(item: T) {
    const { getItemId, allowSelectItem, allowFocusItem } = this.props;
    const id = getItemId(item);
    const allowSelect = this.callAllowSelectItem(allowSelectItem, id, item);
    const allowFocus = this.callAllowFocusItem(allowFocusItem, id, item);
    if (allowSelect && allowFocus) {
      if (this.props.tags) {
        this.changeState(
          {
            inputStrValue: '',
            value: '',
            isOpen: false,
            menuParentStyle: {},
            highlightedIndex: null,
            changed: false,
          },
          () => {
            this.callOnChange(item);
          }
        );
      } else {
        this.changeState(
          {
            inputStrValue: this.props.getItemName(item),
            value: item,
            isOpen: false,
            menuParentStyle: {},
            // highlightedIndex: null,
            changed: false,
          },
          () => {
            this.callOnChange(item);
            this.inputRef.current.focus();
            this.setIgnoreBlur(false);
          }
        );
      }
    }
  }

  setIgnoreBlur(ignore: boolean) {
    this._ignoreBlur = ignore;
  }

  getFlatTree = (
    rows: TreeType<T>[],
    expandedIds: TreeExpandedType,
    getItemId: (val: T) => IdType
  ) => {
    const prop = {
      index: 0,
      list: [] as T[],
      depthList: [] as number[],
    };
    rows.forEach((node) =>
      this._getFlatTree(node, prop, expandedIds, getItemId, 0)
    );
    return prop;
  };

  _getFlatTree = (
    node: TreeType<T>,
    prop: { index: number; list: T[]; depthList: number[] },
    expandedIds: TreeExpandedType,
    getItemId: (val: T) => IdType,
    depth: number
  ) => {
    prop.list.push(node);
    prop.depthList.push(depth);
    if (expandedIds ? expandedIds[getItemId(node)] : node.expanded) {
      node.children &&
        node.children.forEach((ch) =>
          this._getFlatTree(ch, prop, expandedIds, getItemId, depth + 1)
        );
    }
  };

  // @ts-ignore
  handleExpandCollapse = (node, index, e) => {
    e.stopPropagation();
    e.preventDefault();

    // @ts-ignore
    const { expandedIds } = this.state;
    const { getItemId } = this.props;
    const expanded = expandedIds[getItemId(node)];

    this.expandNode(node, expanded ? false : true);
  };

  renderMenu() {
    const {
      getItemId,
      getItemName,
      renderTitleItemContent,
      renderItemContent,
      renderItem,
      tree,
      allowSelectItem,
      allowFocusItem,
      colors,
    } = this.props;
    const { changed } = this.state;

    // @ts-ignore
    const items = this.getFilteredItems().map((item, index) => {
      const id = getItemId(item);
      const name = item._titleLabel ? item.name : getItemName(item);
      const allowSelect = this.callAllowSelectItem(allowSelectItem, id, item);
      const allowFocus = this.callAllowFocusItem(allowFocusItem, id, item);
      const treeInfo = tree
        ? {
            // @ts-ignore
            expanded: this.state.expandedIds[id],
            // @ts-ignore
            depth: this.state.itemsDepth[index],
            // @ts-ignore
            onExpandCollapse: (e) => this.handleExpandCollapse(item, index, e),
          }
        : null;
      // @ts-ignore
      const element = renderItem(
        item,
        id,
        name,
        item._titleLabel ? renderTitleItemContent : renderItemContent,
        this.state.highlightedIndex === index,
        !changed && this.state.value && getItemId(this.state.value) === id,
        allowSelect,
        allowFocus,
        treeInfo,
        this.props.getItemRenderClass,
        colors
      );
      return React.cloneElement(element, {
        onMouseDown: () => this.setIgnoreBlur(true),
        /*  onMouseEnter: () => this.highlightItemFromMouse(index),*/
        onClick: () => this.selectItemFromMouse(item),
        ref: `item-${index}`,
        key: `item-${index}`,
      });
    });

    if (items.length > 0) {
      return this.renderMenuContainer(items);
    } else {
      return null;
    }
  }

  handleInputBlur = () => {
    _debugStates &&
      console.log(
        '...handleInputBlur',
        'state.hasFocus',
        this.state.hasFocus,
        '_ignoreBlur',
        this._ignoreBlur
      );

    if (!this._ignoreBlur) {
      const newState = { hasFocus: false };

      const { changed } = this.state;
      let callback;
      if (this.props.allowCreateItems && changed) {
        const item = this.props.getNewItem(this.state.inputStrValue);

        // @ts-ignore
        newState.inputStrValue = '';
        // @ts-ignore
        newState.value = null;
        // @ts-ignore
        newState.changed = false;
        // @ts-ignore
        newState.highlightedIndex = null;
        this.changeState(newState, () => {
          // @ts-ignore
          this.callOnChange(item);
        });
      } else {
        // Pokud byla hodnota v input změněná a nepotvrdil ji, budeme brát, jako že ji smazal (pokud je zakázáno null values, tak tam necháme tu původní, pokud nějaká byla)
        if (changed) {
          const { allowNullValue = true } = this.props;
          if (!allowNullValue) {
            // @ts-ignore
            newState.changed = false;
          } else {
            // @ts-ignore
            newState.inputStrValue = '';
            // @ts-ignore
            newState.value = null;
            // @ts-ignore                    newState.changed = false;
            // @ts-ignore
            newState.highlightedIndex = null;
            // @ts-ignore
            callback = () => {
              this.callOnChange(null);
            };
          }
        }
        this.changeState(newState, callback);
      }

      this.closeMenu(true, false, true);
    } else {
      this._ignoreBlur = false;
    }

    return true;
  };

  handleInputFocus = () => {
    _debugStates &&
      console.log(
        '...handleInputFocus',
        'state.hasFocus',
        this.state.hasFocus,
        '_ignoreBlur',
        this._ignoreBlur
      );

    if (this.state.hasFocus) {
      // @ts-ignore
      return;
    }

    this.changeState({ hasFocus: true });

    const { onFocus, showMenuOnFocus } = this.props;
    if (!this._ignoreBlur) {
      // @ts-ignore
      onFocus && onFocus();
    } else {
      this._ignoreBlur = false;
    }

    if (showMenuOnFocus) {
      this.openMenu();
    }

    return true;
  };

  openMenu = (proceedFilter = true) => {
    if (this.props.disabled || this.props.readOnly || this.state.isOpen) {
      return;
    }

    let result;
    let items;
    if (proceedFilter) {
      const filterText = this.state.changed ? this.state.inputStrValue : '';
      result = this.getFilteredResult(
        filterText,
        this.state.changed,
        this.props,
        this.state,
        this.props.items
      );
      // @ts-ignore
      items = result.items;
    } else {
      items = this.getFilteredItems();
    }

    // Pokud je vybrána nějaká hodnota, zobrazíme menu s označením dané položky jako highlighted, ale jen pokud nebyla změna v input textu!
    // @ts-ignore
    const { getItemId } = this.props;
    const { value } = this.state;
    let highlightedIndex = null;
    if (!this.state.changed) {
      const { getItemId } = this.props;
      highlightedIndex = this.getHighlightedIndexByValue(
        value,
        items,
        getItemId
      );
    } else {
      highlightedIndex = this.state.highlightedIndex;
    }

    this.props.onOpenMenu && this.props.onOpenMenu();
    this.changeState(
      {
        ...result,
        highlightedIndex,
      },
      () => {
        this.changeState({
          isOpen: true,
        });
        this.focus();
      }
    );
  };

  // @ts-ignore
  getHighlightedIndexByValue = (value, items, getItemId) => {
    let index = null;

    if (value) {
      const selectedId = getItemId(value);
      for (let a = 0; a < items.length; a++) {
        if (getItemId(items[a]) === selectedId) {
          index = a;
          // break;   // nemůže být, chceme tu poslení, protože chceme přeskočit oblíbené položky
        }
      }
    }
    return index;
  };

  closeMenu = (
    callBlurAfterSetState = false,
    changeHighlightedIndex = false,
    callFocusOnInput = false
  ) => {
    if (
      !this.state.isOpen &&
      this.state.highlightedIndex === null &&
      this.state.inputStrValue === this.props.getItemName(this.state.value)
    ) {
      // Není třeba nastavovat state
      if (callBlurAfterSetState) {
        const { value } = this.state;
        this.callOnBlur(value);
      }
      return;
    }

    // @ts-ignore
    const { getItemId, value } = this.props;
    const items = this.getFilteredItems();
    const realValue = this.getRealValue(value);

    var addState = {
      isOpen: false,
      menuParentStyle: {},
      inputStrValue: this.props.getItemName(this.state.value),
      // changed: false
    };

    if (changeHighlightedIndex) {
      // @ts-ignore
      addState.highlightedIndex = this.getHighlightedIndexByValue(
        realValue,
        items,
        getItemId
      );
    }

    _debugStates &&
      console.log(
        '#### closeMenu',
        'prev state',
        this.state,
        'props',
        this.props,
        'state change',
        addState
      );
    this.changeState(addState, () => {
      //this.inputRef.current.select()
      if (callBlurAfterSetState) {
        const { value } = this.state;
        this.callOnBlur(value);
      }

      this.props.onCloseMenu && this.props.onCloseMenu();
    });
    if (callFocusOnInput && !callBlurAfterSetState) {
      this.focus();
    }
  };

  showDropdown = () => {
    return true;
  };

  // @ts-ignore
  handleInputClick = (e) => {
    const { hasFocus } = this.state;
    if (!hasFocus) {
      e.preventDefault();
      this.inputRef.current.select();
      // this.focus();
    } else {
      const { isOpen } = this.state;
      const { showMenuOnFocus } = this.props;
      if (showMenuOnFocus && !isOpen) {
        this.openMenu(false);
      }
    }
  };

  render() {
    // @ts-ignore
    const {
      hasDropdownIcon,
      getDropDownIcon,
      favoriteItems,
      error,
      title,
      touched,
      inline,
      inputRef,
      dataTest,
    } = this.props;

    const hasError = touched && error;
    let inlineProps = {};
    if (inline) {
      // @ts-ignore
      error && (inlineProps.title = title ? title + '/' + error : error);
    }

    var clsMain = 'autocomplete-control-container';
    // @ts-ignore
    if (this.props.className) {
      // @ts-ignore
      clsMain += ' ' + this.props.className;
    }

    // @ts-ignore
    const glyph = hasDropdownIcon
      ? getDropDownIcon(this.state.isOpen)
      : undefined;
    _debugStates &&
      console.log('RENDER', 'props', this.props, 'state', this.state);

    // var bootInfo = getBootstrapInputComponentInfo(this.props);
    // var cls = bootInfo.cls;
    var cls = 'autocomplete-wrapper-out';
    if (!hasDropdownIcon) {
      cls += ' autocomplete-no-dropdown-icon';
    }

    // @ts-ignore
    const { leftElement, ...restInputProps } = this.props.inputProps;

    return (
      <div className={clsMain}>
        <div className="autocomplete-control-box">
          {/*{this.state.changed ? "changed" : "-"}*/}
          {/*{this.state.highlightedIndex}*/}
          <div className={cls}>
            {
              // @ts-ignore
              this.props.label && (
                <label className="control-label">{this.props.label}</label>
              )
            }
            <div
              key="inputWrapper"
              className={
                'autocomplete-input-container form-groupa' +
                (hasError ? ' has-error' : '')
              }
            >
              <div className={'ui-v4-input-group ui-v4-field-input'}>
                {leftElement && (
                  <span className={'ui-v4-input-group-left'}>
                    {leftElement}
                  </span>
                )}
                <input
                  data-test={dataTest ? `input-${dataTest}` : undefined}
                  key="input"
                  type="text"
                  {...inlineProps}
                  {...restInputProps}
                  className={classNames(
                    'ui-v4-input',
                    restInputProps?.className
                  )}
                  // @ts-ignore
                  disabled={this.props.disabled}
                  readOnly={this.props.readOnly}
                  role="combobox"
                  aria-autocomplete="both"
                  ref={this.inputRef}
                  onFocus={this.handleInputFocus}
                  onBlur={this.handleInputBlur}
                  onChange={this.handleChange}
                  onKeyDown={this.handleKeyDown}
                  onKeyUp={this.handleKeyUp}
                  onMouseDown={this.handleInputClick}
                  value={this.state.inputStrValue}
                  placeholder={this.props.placeholder}
                  autoFocus={this.props.autoFocus}
                />
              </div>
              {this.showDropdown() && (
                <div
                  // @ts-ignore
                  disabled={this.props.disabled}
                  ref="openClose"
                  className={classNames(
                    'btn btn-default autocomplete-dropdown-button',
                    {
                      ['autocomplete-dropdown-nobutton']:
                        !this.props.dropDownIconClickOpenMenu,
                      opened: this.state.isOpen,
                      closed: !this.state.isOpen,
                      disabled: this.props.disabled,
                      readOnly: this.props.readOnly,
                    }
                  )}
                  onClick={
                    !this.props.dropDownIconClickOpenMenu ||
                    this.props.disabled ||
                    this.props.readOnly
                      ? undefined
                      : () => {
                          this.state.isOpen
                            ? this.closeMenu(false, true, true)
                            : this.openMenu();
                        }
                  }
                >
                  {hasDropdownIcon && glyph && (
                    <FontAwesomeIcon
                      fixedWidth
                      className="dropdown-button"
                      icon={glyph}
                    />
                  )}
                </div>
              )}
              {this.props.actions && (
                <div ref="actions">{this.props.actions}</div>
              )}
              {/*{!inline && hasError && <HelpBlock>{error}</HelpBlock>}*/}
            </div>
            {this.state.isOpen && this.renderMenu()}
            {
              // @ts-ignore
              this.props.help && (
                <span className="help-block">{this.props.help}</span>
              )
            }
          </div>
        </div>
      </div>
    );
  }
}
/*
class TextInput extends AbstractReactComponent {

    shouldComponentUpdate(nextProps, nextState) {
        return !propsEquals(this.props, nextProps);
    }

    render() {
        return <input {...this.props} />
    }
}
*/

const keyDownHandlers = {
  // @ts-ignore
  ArrowRight: function (event) {
    const { tree } = this.props;
    if (tree) {
      const { highlightedIndex } = this.state;

      if (highlightedIndex != null) {
        event.preventDefault(); // u stromu nechceme posouvat po inputu, pokud je highlightedIndex = má focus list s položkami a klávesy fungují na rozbalení a zabalení stromu
        event.stopPropagation();
      }

      const { expandedIds } = this.state;
      if (highlightedIndex !== null) {
        const items = this.getFilteredItems();
        const node = items[highlightedIndex];
        const id = this.props.getItemId(node);
        if (node.children && node.children.length > 0) {
          if (expandedIds[id]) {
            // je rozbalený, přejdeme na potomka
            if (highlightedIndex + 1 < items.length) {
              // this._performAutoCompleteOnKeyUp = true;
              this.changeState({
                highlightedIndex: highlightedIndex + 1,
              });
            }
          } else {
            // není rozbalený, rozbalíme
            this.expandNode(node, true);
          }
        }
      }
    }
  },
  // @ts-ignore
  ArrowLeft: function (event) {
    const { tree } = this.props;
    if (tree) {
      const { highlightedIndex } = this.state;

      if (highlightedIndex != null) {
        event.preventDefault(); // u stromu nechceme posouvat po inputu, pokud je highlightedIndex = má focus list s položkami a klávesy fungují na rozbalení a zabalení stromu
        event.stopPropagation();
      }

      const { expandedIds } = this.state;
      if (highlightedIndex !== null) {
        const items = this.getFilteredItems();
        const node = items[highlightedIndex];
        const id = this.props.getItemId(node);
        if (node.children && node.children.length > 0 && expandedIds[id]) {
          // je rozbalený, zablíme
          this.expandNode(node, false);
        } else {
          // není rozbalený, přejmede na parenta
          const currDepth = this.state.itemsDepth[highlightedIndex];
          let index = highlightedIndex - 1;
          while (index >= 0 && this.state.itemsDepth[index] >= currDepth) {
            index--;
          }
          if (index >= 0) {
            this.changeState({
              highlightedIndex: index,
            });
          }
        }
      }
    }
  },
  Home: () => {},
  End: () => {},
  Alt: () => {},
  Tab: () => {},
  // @ts-ignore
  ArrowDown: function (event) {
    event.preventDefault();
    event.stopPropagation();

    if (event.altKey) {
      if (this.showDropdown()) {
        this.openMenu();
      }
    } else {
      const { isOpen, highlightedIndex } = this.state;
      const { tree } = this.props;

      const index = this.getNextFocusableItem(highlightedIndex, !tree);

      this.changeState({
        highlightedIndex: index,
      });

      if (!isOpen) {
        const { value } = this.props;
        const realValue = this.getRealValue(value);
        const items = this.getFilteredItems();
        const newValue = index != null ? items[index] : null;
        if (newValue !== realValue) {
          this.callOnChange(newValue);
        }
      }
    }
  },

  // @ts-ignore
  ArrowUp: function (event) {
    event.preventDefault();
    event.stopPropagation();

    if (event.altKey) {
      this.closeMenu(false, true, true);
    } else {
      const { isOpen, highlightedIndex } = this.state;
      const { tree } = this.props;

      const index = this.getPrevFocusableItem(highlightedIndex, !tree);

      this.changeState({
        highlightedIndex: index,
      });

      if (!isOpen) {
        const { value } = this.props;
        const realValue = this.getRealValue(value);
        const items = this.getFilteredItems();
        const newValue = index != null ? items[index] : null;
        if (newValue !== realValue) {
          this.callOnChange(newValue);
        }
      }
    }
  },

  // @ts-ignore
  Enter: function (event) {
    if (this.state.isOpen === false && !this.state.changed) {
      this.props.onSearch && this.props.onSearch();
      // already selected this, do nothing
      return;
    }
    if (this.props.tags) {
      event.stopPropagation();
      event.preventDefault();
      // @ts-ignore
      let id, item;
      if (this.state.highlightedIndex == null) {
        if (this.props.allowCreateItems) {
          item = this.props.getNewItem(this.state.inputStrValue);
          id = this.props.getItemId(item);
        } else {
          id = null;
          if (!this.props.onSearchByText) {
            item = {
              name: this.state.inputStrValue,
            };
          }
        }
      } else {
        item = this.getFilteredItems()[this.state.highlightedIndex];
        id = this.props.getItemId(item);
      }

      if (this.props.onSearchByText && !item) {
        const searchText = this.state.inputStrValue;
        this.changeState(
          {
            inputStrValue: '',
            value: '',
            isOpen: false,
            menuParentStyle: {},
            // highlightedIndex: null
          },
          () => {
            // @ts-ignore
            this.props.onSearchByText(searchText);
          }
        );
      } else if (
        this.callAllowSelectItem(this.props.allowSelectItem, id, item)
      ) {
        this.changeState(
          {
            inputStrValue: '',
            value: '',
            isOpen: false,
            menuParentStyle: {},
            // highlightedIndex: null
          },
          () => {
            // @ts-ignore
            this.callOnChange(item);
          }
        );
      }
    } else {
      if (this.state.highlightedIndex == null && !this.props.allowCreateItems) {
        event.stopPropagation();
        event.preventDefault();
        if (this.props.onSearchByText) {
          event.stopPropagation();
          event.preventDefault();
          const searchValue = this.state.inputStrValue;

          this.changeState(
            {
              isOpen: false,
              menuParentStyle: {},
              inputStrValue: '',
              value: '',
            },
            () => {
              // this.inputRef.current.select();
              this.props.onSearchByText(searchValue);
              this.callOnChange(null);
            }
          );
        } else {
          const { allowNullValue = true } = this.props;
          if (!allowNullValue) {
            this.changeState({
              changed: false,
            });
            this.closeMenu(false, true, true);
          } else {
            // hit enter after focus but before typing anything so no autocomplete attempt yet
            this.changeState(
              {
                isOpen: false,
                menuParentStyle: {},
                inputStrValue: '',
                value: null,
              },
              () => {
                this.inputRef.current.select();
                this.callOnChange(null);
                this.props.onSearch && this.props.onSearch();
              }
            );
          }
        }
      } else {
        event.stopPropagation();
        event.preventDefault();

        let item: any;
        let id: any;
        if (
          this.state.highlightedIndex == null &&
          this.props.allowCreateItems
        ) {
          item = this.props.getNewItem(this.state.inputStrValue);
          id = this.props.getItemId(item);
        } else {
          item = this.getFilteredItems()[this.state.highlightedIndex];
          id = this.props.getItemId(item);
        }

        if (this.callAllowSelectItem(this.props.allowSelectItem, id, item)) {
          this.changeState(
            {
              inputStrValue: this.props.getItemName(item),
              value: item,
              isOpen: false,
              menuParentStyle: {},
              highlightedIndex: null,
              changed: false,
            },
            () => {
              //this.inputRef.current.focus() // TODO: file issue
              this.inputRef.current.setSelectionRange(
                this.state.inputStrValue?.length || 0,
                this.state.inputStrValue?.length || 0
              );
              this.callOnChange(item);
            }
          );
        }
      }
    }
  },
};

const keyUpHandlers = {
  // @ts-ignore
  Escape: function (event) {
    if (this.state.isOpen) {
      event.stopPropagation();
      event.preventDefault();

      const { changed } = this.state;
      if (changed) {
        if (this.props.allowCreateItems) {
          const item = this.props.getNewItem(this.state.inputStrValue);

          this.changeState(
            {
              inputStrValue: '',
              value: '',
              isOpen: false,
              menuParentStyle: {},
              // highlightedIndex: null
            },
            () => {
              // @ts-ignore
              this.callOnChange(item);
            }
          );
        } else {
          this.changeState({
            changed: false,
          });
        }
      }

      this.closeMenu(false, true, true);
    }
  },
};
